module.exports = __webpack_public_path__ + "dingbeauty-build/img/footer_background_logo.2366c5c9.svg";